import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function DM_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-5'>1. Introduction to Digital Marketing</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to Digital marketing & Its basics, Types of Digital Marketing, Advantages of Digital marketing, Digital marketing Era & Career.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-5'>2. SEO & SMM</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to Search Engine optimization, SEO Tools & it’s working, Intro to Social media marketing, social media marketing apps & how to do social media marketing.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-5'>3. Intro to Designing & Ads</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to Google ads, how to search ads, how to display Ads, Tools for ads creation.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-5'>4. Email & Content Marketing</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Email marketing & steps & it’s working, Content marketing (Blogs Posts/infographics/videos/editing/eBooks/white papers).     
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-5'>5. Affiliate Marketing</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to Affiliate marketing, Importance & it’s working, Steps of affiliate marketing (Registrations/ signs-ups/ sales/ subscription/ network).
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-5'>6. Paid Social & seach Advertising Marketing</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to social & search paid advertising, Different platforms for social & search paid advertising, SERP.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-5'>7. Quora Marketing</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to Quora marketing, Different methods & tools of survey.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-5'>8. Freelancing & Mobile Marketing</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Understanding freelancing marketing 7 its tools.
          <br></br>Facebook/ INSTAGRAM/twitter /LinkedIni.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel9bh-content"
          id="panel9bh-header"
        >
          <Typography className='fs-5'>9. Introduction to Google Analytics & tools</Typography>
        </AccordionSummary>
        {/* <AccordionDetails>
          <Typography>
          Neuron Diagram Neuron Models & NETWORK FUNCTIONS of Neurons activation Functions of Gradient descent & Stochastic Ramp function & sigmoid function & Gaussian function.
          </Typography>
        </AccordionDetails> */}
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel10bh-content"
          id="panel10bh-header"
        >
          <Typography className='fs-5'>10. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major project, Project overview.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
